import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import * as ReasonActions from '../../../actions/reason_actions';
import * as SettingAction from '../../../actions/settingScreen_actions';
import * as UserActions from '../../../actions/user_actions';
import * as QuestionnaireActions from '../../../actions/questionnaire_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
import { RestPwdDialog } from '../../../components/reset_pwd_dialog';
let screenIdentifier = 'patientsDetails';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Modal from 'react-modal';
// import { classNames } from 'react-select/src/utils';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { Loader } from './../../loader';


export var PatientsDetails = React.createClass({
    getInitialState() {
        return {
            facilitiListLength: false,
            modal: false, modal_msg: "", edit_mode: null, modal_pwd: false, isActivation: false,
            activeStatus: "", patient_id: "", p_uq: null, resetpwd: false, resetpwdClicked: false,
            fac_id: false, isDeactive: false, deactivateClicked: false,
            //currentTriggerTime: "4PM - 6PM",
            resetPasswordResponseError: null, timerTrigger: false, triggerTime: false, redFlagCalled: false, redFlagData: null, 
            // triggerDuration: false,
            resloveRedflagsClicked: false,
            selectedTab: 0,
            currentDailyTriggerTime: null,
            showDailyTriggerTime: false,
            currentWeeklyTriggerTime: null,
            showWeeklyTriggerTime: false,
            sortDirection: '',
            loader: false,
            showFlagsModel: false,
            showResponseModel: false,
            reasonValue: '',
            viewCustomREason: false,
            textValue: '',
            responseReason: [],
            selectedResponse: '',
            selectedId: '',
            index: '',
            submit: false,
            flagData: '',
            isResolved: true,
            customReason: '',
            errors: '',
            showLogs: '',
            logText: '',
            flagStatus: false,
            selectedFromDate: null,
            selectedToDate: null,
            descriptionFilters: [
                'No survey from the patient for the past 3 days',
                'No medication for the past 3 days',
                'Conflicts for the past 3 days',
                'No sleep for the past 3 days',
                'Weekly survey symptom score increased by 2 points compared to two weeks ago'
            ],
            selectedDescription: '',
            statusList: [{ name: 'Resolved', id: 0 }, { name: 'Unresolved', id: 1 }],
            selectedStatus: '',
            filterError: '',
            resolvedRedFlagsHistory: [],
            showResolvedFlagsHistoryPopup: false,
            showLoader: false,
            currentWeeklyTriggerDay: null,
            // currentReportedPeriod: 'PAST 30 DAYS',
            showWeeklyTriggerDay: null,
            // showReportPeriod: null,
            isDailySurveyEdit: true,
            isWeeklySurveyTimeEdit: true,
            isWeeklySurveyDayEdit: true,
            // isReportPeriodEdit: true,
        }
    },

    componentWillMount() {
        //this.props.FacilitiesDetails.FaciliteAdminUser = {};
        let data = {
            "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.id,
            "fromDate": "all"
        }

        this.props.Dispatch(UserActions.get_survey_list(data));
        this.props.Dispatch(PatientsActions.get_patient_info(this.props.FacilitiesDetails.FaciliteAdminUser.data.id + "/" + this.props.UserDetails.selectdUserFacilityID));

    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.Reasons) {
            this.setState({ responseReason: nextProps.Reasons })
        }
        if (nextProps.Updated) {
            if (nextProps.Updated.status === 200) {
                this.setState({ showLoader: false });
                this.props.Dispatch(PatientsActions.get_patient_info(this.props.FacilitiesDetails.FaciliteAdminUser.data.id + "/" + this.props.UserDetails.selectdUserFacilityID));

                this.setState({ resloveRedflagsClicked: false, redFlagCalled: true });

                let patient_details = this.props.FacilitiesDetails.FaciliteAdminUser;
                let data = patient_details.data.id + "/" + this.props.UserDetails.selectdUserFacilityID;
                this.getRedFlags();
                // this.props.Dispatch(PatientsActions.get_redFlag_data(data));
                this.props.Dispatch(ReasonActions.put_response(null));
            }
            // let _redFlag = this.state.redFlagData;
            // _redFlag[this.state.index].active = false;
            // this.setState({redFlagData: _redFlag}, ()=>{console.log(this.state.redFlagData, 'redflagdata')})
        }

        if (nextProps.LogsList) {
            !this.state.showLogs && this.setState({ showLogs: true });
            document.getElementById('logText') && (document.getElementById('logText').innerHTML = '')

        }

        if (nextProps.LogResponse) {
            if (nextProps.LogResponse.status === 200) {
                this.props.Dispatch(ReasonActions.postLogsResponse(null));
                if (this.state.selectedId === 0) {
                    this.setState({ logText: '', selectedId: '', showLogs: false });
                } else {
                    this.props.Dispatch(ReasonActions.getLogs(this.state.selectedId));
                    this.setState({ logText: '' });
                }

            }
        }

        // if(JSON.stringify(nextProps.Updated) !== JSON.stringify(this.props.Updated)){
        //     console.log(this.state.responseReason, 'asdfghj')
        //     let _redFlag = this.state.redFlagData;
        //     _redFlag[this.state.index].active = false;
        //     _redFlag[this.state.index].reason = this.state.responseReason.data[this.state.index].reason;
        //      this.state.responseReason.data[this.state.index].reason;   


        //     this.setState({redFlagData: _redFlag, isResolved:false})
        // }
        //this.state.resetpwdClicked && nextProps.Setting.Changepassword && nextProps.Setting.Changepassword.status === 200 && this.setState({ 'resetpwd': false,modal_pwd:true,modal_msg:"Updated Successfully",resetpwdClicked:false });
        // Reset Password
        if (this.state.resetpwdClicked) {
            this.setState({ resetpwdClicked: false });
            if (nextProps.Setting.Changepassword && nextProps.Setting.Changepassword.status === 200) {
                this.setState({ resetpwd: false, modal_pwd: true, modal_msg: nextProps.Setting.Changepassword.message });
            }
            else {
                this.setState({ resetPasswordResponseError: nextProps.Setting.Changepassword.message });
            }
        }

        var isActive = nextProps.Setting.StaffStatus;
        if (this.state.deactivateClicked && isActive && isActive.status == 200) {
            let patientsID = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
            isActive ? nextProps.FacilitiesDetails.ActivateAdmin = null : "";
            this.setState({ deactivateClicked: false });
            this.props.Dispatch(FacilitiesActions.getAdminUserById(patientsID + "/" + this.props.UserDetails.selectdUserFacilityID));

        }
        if (this.state.timerTrigger) {
            this.setState({ timerTrigger: false, modal_pwd: true, modal_msg: nextProps.UserDetails.TriggerTime.message })
        }
        // if (this.state.triggerDuration) {
        //     this.setState({ triggerDuration: false, modal_pwd: true, modal_msg: 'Report Period Updated Successfully.' })
        // }
        if (this.state.redFlagCalled) {
            if (this.props.TimeStamp !== nextProps.TimeStamp) {
                this.setState({ loader: false });
                let redFlagProps = nextProps.PatientsDetails.RedflagPatient;
                redFlagProps && redFlagProps.status == 200 && this.setState({ redFlagCalled: false, redFlagData: redFlagProps.data.result });
            }
        }
        if (this.state.resloveRedflagsClicked) {
            this.props.Dispatch(PatientsActions.get_patient_info(this.props.FacilitiesDetails.FaciliteAdminUser.data.id + "/" + this.props.UserDetails.selectdUserFacilityID));
            this.setState({ showLoader: false });

            this.setState({ resloveRedflagsClicked: false, redFlagCalled: true });

            let patient_details = this.props.FacilitiesDetails.FaciliteAdminUser;
            let data = patient_details.data.id + "/" + this.props.UserDetails.selectdUserFacilityID;
            this.getRedFlags();
            // this.props.Dispatch(PatientsActions.get_redFlag_data(data));
        }
    },

    getRedFlags() {
        let searchInfo = {};
        let patient_details = this.props.FacilitiesDetails.FaciliteAdminUser;
        let data = patient_details.data.id + "/" + this.props.UserDetails.selectdUserFacilityID;
        // "reason": "string"
        this.setState({ redFlagCalled: true });

        if (this.state.selectedFromDate && this.state.selectedToDate) {
            let date = this.state.selectedFromDate;
            searchInfo['fromdate'] = (date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())))
            let toDate = this.state.selectedToDate;
            searchInfo['todate'] = (toDate.getFullYear() + '-' + ((toDate.getMonth() > 8) ? (toDate.getMonth() + 1) : ('0' + (toDate.getMonth() + 1))) + '-' + ((toDate.getDate() > 9) ? toDate.getDate() : ('0' + toDate.getDate())))
        }


        this.state.selectedDescription !== '' && (searchInfo['description'] = this.state.selectedDescription)
        this.state.selectedStatus !== '' && (searchInfo['status'] = this.state.selectedStatus)

        this.setState({ showLoader: false });

        this.props.Dispatch(PatientsActions.get_redFlag_list(data, searchInfo));

    },
    componentDidMount() {
        let patient_details = this.props.FacilitiesDetails.FaciliteAdminUser;
        let data = patient_details.data.id + "/" + this.props.UserDetails.selectdUserFacilityID;
        this.setState({ resloveRedflagsClicked: false, redFlagCalled: true });
        this.getRedFlags();
        // this.props.Dispatch(PatientsActions.get_redFlag_data(data));
        let tab = validate.getUrlParam("tab");
        if (tab && tab == 'red_flag') {
            this.state.selectedTab = 1
        }
    },



    handlePatientDetails(id, key) {
        this.setState({
            showFlagsModel: true,
            selectedId: id,
            index: key
        });
        // this.setState({selectedId:id})
        // this.setState({index: key});
        this.props.Dispatch(ReasonActions.getReasons());
        // this.props.Dispatch(ReasonActions.getReasons(data, id, reasonId));
    },

    updatePatientDetails() {
        this.setState({ showLoader: true });

        if (this.state.selectedResponse === '12' && this.state.customReason === '') {
            this.setState({ errors: 'Reason is mandatory' });
        } else if (this.state.customReason.charAt(0) === ' ') {
            this.setState({ errors: 'Reason should not start with space.' });
        } else {
            this.setState({ showLoader: true });
            let payload = {
                "reason": this.state.selectedResponse
            }
            if (this.state.selectedId === 0) {
                this.state.selectedDescription !== '' && (payload['description'] = this.state.selectedDescription)
                if (this.state.selectedFromDate && this.state.selectedToDate) {
                    let date = this.state.selectedFromDate;
                    payload['fromdate'] = (date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())))
                    let toDate = this.state.selectedToDate;
                    payload['todate'] = (toDate.getFullYear() + '-' + ((toDate.getMonth() > 8) ? (toDate.getMonth() + 1) : ('0' + (toDate.getMonth() + 1))) + '-' + ((toDate.getDate() > 9) ? toDate.getDate() : ('0' + toDate.getDate())))
                }
                this.state.selectedResponse === '12' && (payload['otherReason'] = this.state.customReason);
                this.state.selectedStatus && (payload['status'] = this.state.selectedStatus);


            }
            this.props.Dispatch(ReasonActions.updateReason(this.state.selectedId, this.state.selectedResponse,
                (this.state.selectedResponse === '12' ? this.state.customReason : null),
                (this.state.selectedId === 0 ? payload : null)));
            // if (this.state.selectedId !== 0) {

            // } else {
            //     let flagId = this.props.FacilitiesDetails.FaciliteAdminUser.data.id
            // }

            this.setState({ viewCustomREason: false, selectedResponse: '' });
            this.setState({
                showFlagsModel: false,
                selectedId: '',
                index: '',
                isResolved: true,
                errors: '',
                customReason: ''
            });
        }

    },

    handleUpdate(reason) {
        this.props.Dispatch(ReasonActions.getReasons());
        this.setState({ showFlagsModel: true, selectedId: reason.id });
        this.setState({ flagData: reason });
        // this.setState({indexed: key});
    },
    closePatientDetails() {
        this.setState({ viewCustomREason: false, selectedResponse: '' });
        this.setState({ showFlagsModel: false });
    },
    closeResponse() {
        this.setState({ showResponseModel: false });
    },
    getPatientDetail() {

        var patient_details = this.props.FacilitiesDetails.FaciliteAdminUser.data;
        return patient_details;
    },
    editPatientyAdmin(e) {

        var patient_id = e.target.attributes['data-staf-id'].value;



    },
    resetPwdModal() { this.setState({ 'resetpwd': true }) },
    resetPassword(obj) {

        var data = {};
        var new_pwd = obj.refs.new_pwd.value.trim();
        var password = obj.refs.re_pwd.value.trim();
        if (new_pwd != password) {
            return false;
        }

        data.id = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        data.uniqueKey = this.props.FacilitiesDetails.FaciliteAdminUser.data.uniqueKey;
        data.password = password;
        data.isPasswordChange = obj.refs.isPasswordChange.checked ? false : true;
        this.props.Dispatch(SettingAction.changePassword(data));
        this.setState({ resetpwdClicked: true });
    },
    handleSelect(index, last) {
        this.setState({ selectedTab: index });

    },
    deactivatePatient(event) {

        let activeStatus = event.target.dataset.isactive;
        let patient_id = event.target.dataset.patient_id;
        let p_uq = event.target.dataset.uq;
        let fac_id = event.target.dataset.fac_id;

        let msg = activeStatus === "1" ? "Are you sure you want to activate this account?" : "Are you sure you want to deactivate this account?";
        let isdeactive = activeStatus === "1" ? false : true;
        this.setState({ isActivation: true, activeStatus: activeStatus, patient_id: patient_id, modal_msg: msg, p_uq: p_uq, fac_id: fac_id, isDeactive: isdeactive });

    },
    deactivatePatientYes() {

        let data = {};
        let activeStatus = this.state.activeStatus;
        data.uniqueKey = this.state.p_uq;
        data.id = this.state.patient_id;
        data.facilityId = this.state.fac_id;
        data.isDeactive = this.state.isDeactive;
        this.props.Dispatch(SettingAction.updateStaffSatus(data));
        this.setState({ isActivation: false, deactivateClicked: true });
    },
    closebox() {
        this.setState({ modal_pwd: false, modal: false, modal_msg: "", isActivation: false, resetpwd: false, resetPasswordResponseError: null });

    },
    removeResetPasswordResponseError() {
        this.setState({ resetPasswordResponseError: null });
    },
    editPatient() {
        this.props.router.push('/edit-patients-details');
    },
    addOptionalQuestions() {

        let patientId = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(QuestionnaireActions.adminGetAllUniqueQuestion(patientId + '/' + facilitiesID));
        this.props.router.push('/add-optional-questions');
    },
    triggerWeeklyTimer(event) {
        var data = {
            "uniqueKey": event.target.dataset.uq,
            "id": event.target.dataset.patient_id,
            "facilityId": this.props.UserDetails.selectdUserFacilityID,
            "weeklyTriggerTime": event.target.dataset.hour,
        };
        this.setState({ timerTrigger: true, showWeeklyTriggerTime: false, currentWeeklyTriggerTime: event.target.innerHTML, isWeeklySurveyTimeEdit: true });
        this.props.Dispatch(UserActions.setUserTriggerTime(data));
    },

    triggerDailyTimer(event) {
        var data = {
            "uniqueKey": event.target.dataset.uq,
            "id": event.target.dataset.patient_id,
            "facilityId": this.props.UserDetails.selectdUserFacilityID,
            "dailyTriggerTime": event.target.dataset.hour,
        };
        this.setState({ timerTrigger: true, showDailyTriggerTime: false, currentDailyTriggerTime: event.target.innerHTML, isDailySurveyEdit: true });
        this.props.Dispatch(UserActions.setUserTriggerTime(data));
    },

    triggerWeeklyDay(event) {
        var data = {
            "uniqueKey": event.target.dataset.uq,
            "id": event.target.dataset.patient_id,
            "facilityId": this.props.UserDetails.selectdUserFacilityID,
            "weeklyTriggerDay": event.target.id,
        };
        this.setState({ timerTrigger: true, showWeeklyTriggerDay: false, currentWeeklyTriggerDay: event.target.innerHTML, isWeeklySurveyDayEdit: true });
        this.props.Dispatch(UserActions.setUserTriggerTime(data));
    },


    // triggerReportPeriod(event) {
    //     this.props.Dispatch(PatientsActions.get_patient_info(this.props.FacilitiesDetails.FaciliteAdminUser.data.id + "/" + this.props.UserDetails.selectdUserFacilityID + "?duration=" + event.target.id));
    //     this.setState({ triggerDuration: true, showReportPeriod: false, currentReportedPeriod: event.target.innerHTML, isReportPeriodEdit: true });
    // },


    toggleTriggerTime() {
        let stateFlag = this.state.triggerTime ? false : true;
        this.setState({ triggerTime: stateFlag });
    },

    toggleDailyTriggerTime() {
        let stateFlag = this.state.showDailyTriggerTime ? false : true;
        this.setState({ showDailyTriggerTime: stateFlag });
    },

    toggleWeeklyTriggerTime() {
        let stateFlag = this.state.showWeeklyTriggerTime ? false : true;
        this.setState({ showWeeklyTriggerTime: stateFlag });
    },

    toggleWeeklyTriggerDay() {
        let stateFlag = this.state.showWeeklyTriggerDay ? false : true;
        this.setState({ showWeeklyTriggerDay: stateFlag });
    },

    toggleReportPeriod() {
        let stateFlag = this.state.showReportPeriod ? false : true;
        this.setState({ showReportPeriod: stateFlag });
    },


    checkUserSummery() {
        var paitentsDetail = this.getPatientDetail();
        let f_id = paitentsDetail.facilities[0].facility.id, patient_id = paitentsDetail.id;
        this.props.router.push('/survey-analasys?f_id=' + f_id + "&?id=" + patient_id);

    },
    answerdSurvey() {
        let userId = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        let facilitiesID = this.props.UserDetails.selectdUserFacilityID;

        this.props.Dispatch(UserActions.getPatientSurveryResponse(userId + '/' + facilitiesID + '/0/latest'));
        this.props.router.push('/answerd-survey');
    },
    formatDate(e) {
        var datePart = e.match(/\d+/g),
            year = datePart[0], // get only two digits
            month = datePart[1], day = datePart[2];
        return month + '/' + day + '/' + year;
    },

    generateRedFlagList() {
        let redFlagData = this.props.PatientsDetails.RedflagPatient ? this.props.PatientsDetails.RedflagPatient.data.result : [];
        let redFlagCount = 0;
        let currentDate = new Date();
        redFlagCount = redFlagData && redFlagData.length;
        var redFlagList = redFlagData && redFlagData.length ? redFlagData.map(function (list, key) {
            // <td>{list.flagOccuranceDate}</td>
            let fl_Date = new Date();
            let date_matches = (fl_Date.getDate() === currentDate.getDate()) && (fl_Date.getMonth() === currentDate.getMonth())

            //return (<tr key={key} className={ date_matches && 'active'} ><td>{list.flagDate}</td><td>{list.details}</td></tr>)
            return (<tr key={key + Date.now()}
                className={list.active ? '' : 'active'} >
                <td>{this.formatDate(list.flagDate)}</td>
                <td>{list.details}</td>
                {list.active && <td>
                    <button className='btn reslove text-center'
                        style={{ width: 'auto' }} data-id={list.id}
                        onClick={() => this.handlePatientDetails(list.id, key)}>
                        {/* {list.active? 'Un-resolved':'Resolved'} */}
                        UNRESOLVED
                    </button>

                </td>}
                {!list.active && <td>
                    <button className="resolveBtn" onClick={() => this.handleUpdate(list)}>
                        RESOLVED
                    </button>
                </td>}
                <td><button className='btn reslove text-center'
                    style={{ width: 'auto' }} data-id={list.id}
                    onClick={() => this.OnLogsClick(list.id, list.active)}>
                    {/* {list.active? 'Un-resolved':'Resolved'} */}
                    NOTES
                </button> </td>
            </tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        return { list: redFlagList, count: redFlagCount };
    },

    onChange(name, data) {
        if (name === 'reason') {
            if (data === '12') {
                this.setState({ viewCustomREason: true });
            } else {
                this.setState({ viewCustomREason: false });
                // dispatch({ field: 'customReason', value: '' });
            }
        }
        this.setState({ selectedResponse: data })
        // dispatch({ field: name, value: data }); //dispatching key value pair
    },
    // selectionChanged(e) {

    //     // let facilitiesID = this.props.UserData.selectdUserFacilityID;
    //     // this.props.Dispatch(AdminSettingAactions.selectAdmin(facilitiesID));
    //     this.setState({ reasonValue: e.target.value });
    //     event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    // },
    resolve(e) {

        let id = e.target.dataset.id;
        this.props.Dispatch(UserActions.resloveRedflags(id));
        this.setState({ resloveRedflagsClicked: true, loader: true })

    },
    toggleSort() {
        if (this.state.sortDirection === '') {
            this.state.sortDirection = 'a';
        } else if (this.state.sortDirection === 'a') {
            this.state.sortDirection = 'd';
        } else if (this.state.sortDirection === 'd') {
            this.state.sortDirection = '';
        }

        this.setState({}, () => {
            let data = {
                "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.id,
                "fromDate": "all",
                "order": this.state.sortDirection == 'd' ? 0 : 1
            }
            this.props.Dispatch(UserActions.get_survey_list(data));
        });
    },
    navigateToSurveyDetails(event) {
        let surveyType = event.currentTarget.dataset.survey_type === 'DAILY' ? 0 : 1
        let surveyDate = new Date(Number(event.currentTarget.dataset.survey_date));
        let formatedSurveyDate = surveyDate.getFullYear().toString() + '-' + (surveyDate.getMonth() + 1).toString() + '-' + surveyDate.getDate().toString();
        let userId = this.props.FacilitiesDetails.FaciliteAdminUser.data.id;
        let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(UserActions.getPatientSurveryResponse(userId + '/' + facilitiesID + '/' + surveyType + '/' + formatedSurveyDate));
        this.props.router.push('/answerd-survey?date=' + formatedSurveyDate);
    },

    OnLogsClick(id, status) {
        this.props.Dispatch(ReasonActions.getLogs(id));
        this.setState({ selectedId: id, flagStatus: status });
    },

    sendLog() {

        let payload = {
            "notes": this.state.logText
        }
        if (this.state.selectedId === 0) {

            this.state.selectedDescription !== '' && (payload['description'] = this.state.selectedDescription)
            if (this.state.selectedFromDate && this.state.selectedToDate) {
                let date = this.state.selectedFromDate;
                payload['fromdate'] = (date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())))
                let toDate = this.state.selectedToDate;
                payload['todate'] = (toDate.getFullYear() + '-' + ((toDate.getMonth() > 8) ? (toDate.getMonth() + 1) : ('0' + (toDate.getMonth() + 1))) + '-' + ((toDate.getDate() > 9) ? toDate.getDate() : ('0' + toDate.getDate())))
            }
            this.state.selectedResponse === '12' && (payload['otherReason'] = this.state.customReason);
            this.state.selectedStatus && (payload['status'] = this.state.selectedStatus);


        }
        this.props.Dispatch(ReasonActions.postLogs(this.state.selectedId, this.state.logText, payload));

    },

    closeLogs() {
        this.setState({ showLogs: false, logText: '', selectedId: '' });
        this.props.Dispatch(ReasonActions.getLogsList(null));
    },

    onResolveAll() {
        this.handlePatientDetails(0, 0)
    },

    addNotesToAll() {
        this.setState({ selectedId: 0, showLogs: true });
    },

    showResolvedHistoy(resolvedFlagId) {
        this.setState({ showResolvedFlagsHistoryPopup: true });
        this.props.Dispatch(ReasonActions.getHistory(resolvedFlagId));
    },

    render() {
        var paitentsDetail = this.getPatientDetail();
        let UsersByRole = this.props.UserDetails.UsersByRole.data.result;
        let currentUserStatusObj = UsersByRole && _.filter(UsersByRole, function (item) {
            return item.user.id === paitentsDetail.id;
        });

        var surveyListData = this.props.UserDetails.surveyListData;

        var surveList = surveyListData && surveyListData.data.length ? surveyListData.data.map(function (list, key) {

            var date = new Date(list.createdDate);
            var varifyDate = (date.getMonth() + 1) + "-" + ((date.getDate() > 9 ? '' : '0') + date.getDate()) + '-' + date.getFullYear();


            // var month = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
            // var varifyDate = date.getDate() +" "+ month[date.getMonth()] + ", " + date.getFullYear();

            return (<tr key={key} data-survey_type={list.type} data-survey_date={list.createdDate} onClick={this.navigateToSurveyDetails}>
                <td>{list.type}</td><td>{varifyDate}</td><td>{list.therapist}</td><td>{list.psychiatrist}</td><td>{list.surveyStatus}</td><td></td></tr>)
        }, this) : (<tr><td>No records to display.</td></tr>);

        var paitentInfo = this.props.PatientsDetails.PatientInfo ? this.props.PatientsDetails.PatientInfo.data : {};
        let roleID = this.props.UserDetails.selectedUserRoleID;

        let redFlag = this.generateRedFlagList();

        let hours = []
        for (let h = 0; h < 24; h++) {
            let hour = {
                'title': h == 0 ? '12 AM' : (h <= 11 ? h + ' AM' : (h == 12 ? h + ' PM' : h - 12 + ' PM')),
                'value': h,
            }
            hours.push(hour);
        }
        let this_1 = this;

        // dailyTriggerTime - previous value from server
        let dTT = paitentsDetail.triggerTime && paitentsDetail.triggerTime.changedDailyTriggerTime
        if (dTT) {
            dTT = (dTT === 0 ? '12 AM' : (dTT <= 11 ? dTT + ' AM' : (dTT == 12 ? dTT + ' PM' : dTT - 12 + ' PM')));
        }

        // weeklyTriggerTime  - previous value from server
        let wTT = paitentsDetail.triggerTime && paitentsDetail.triggerTime.changedWeeklyTriggerTime
        if (wTT) {
            wTT = (wTT === 0 ? '12 AM' : (wTT <= 11 ? wTT + ' AM' : (wTT == 12 ? wTT + ' PM' : wTT - 12 + ' PM')));
        }

        const startDayPickerProps = {
            disabledDays: {
                after: this.state.selectedToDate ? new Date(this.state.selectedToDate) : new Date(),
            }
        };
        const endDayPickerProps = {
            disabledDays: {
                before: new Date(this.state.selectedFromDate),
                after: new Date(),
            }
        };

        let weeklySurveyDays = [{ key: 0, name: 'SUNDAY' }, { key: 1, name: 'MONDAY' }, { key: 2, name: 'TUESDAY' }, { key: 3, name: 'WEDNESDAY' }, { key: 4, name: 'THURSDAY' },
        { key: 5, name: 'FRIDAY' }, { key: 6, name: 'SATURDAY' }];


        let reportPeriod = [{ key: '1', name: 'PAST 30 DAYS' }, { key: "3", name: 'PAST 3 MONTHS' }, { key: "6", name: 'PAST 6 MONTHS' }];

        // resolvedFlagsHistoryList
        var resolvedFlagsHistoryList = this.props.HistoryResponse && this.props.HistoryResponse.data;

        let WSD = paitentsDetail.triggerTime && paitentsDetail.triggerTime.changedWeeklyTriggerDay;

        const showStatus = () => {
            let status = '';
            if (this.props.FacilitiesDetails.FaciliteAdminUser.data.facilities[0].status === "APPROVE") {
                return status = 'ACTIVE';
            } else if (this.props.FacilitiesDetails.FaciliteAdminUser.data.facilities[0].status === "ACCEPTED") {
                return status = 'PENDING';
            } else {
                return status = this.props.FacilitiesDetails.FaciliteAdminUser.data.facilities[0].status;
            }
        }

        return (

            <div className="dashboard-inner-content">
                <Header loader={this.state.loader} screenIdentifier={screenIdentifier} breadcrumb={true} />
                <div className="admin-details">
                    <div className="breadcrumb-custom">
                        <h2> <Link to="/patients">PATIENTS</Link> {'>'} <Link ></Link>{paitentsDetail.firstName}</h2>
                    </div>
                    <div className="row">
                        <div className="col-xs-5 no-padding">
                            <div className="admin-facility-details">
                                <div className="facility-details-holder">
                                    <h1><span className="icon icon-user"></span>{paitentsDetail.firstName + " " + paitentsDetail.lastName}</h1>
                                    <h4><span className="icon"></span>Username: {paitentsDetail.userName}</h4>
                                    <h4><span className="icon"></span>Status: {this.state.selectedTab == 1 ? "REDFLAG" : showStatus()}</h4>
                                    <p><span className="icon icon-doctor" title="Prescriber"></span> {(paitentsDetail.psychiatrist ? paitentsDetail.psychiatrist.firstName + " " + paitentsDetail.psychiatrist.lastName : 'NA')}</p>
                                    <p><span className="icon icon-doctor" title="Therapist"></span> {(paitentsDetail.therapist ? paitentsDetail.therapist.firstName + " " + paitentsDetail.therapist.lastName : 'NA')}</p>
                                    <p><span className="icon icon-phone"></span>{paitentsDetail.mobile}</p>
                                    <p><span className="icon icon-email"></span>{paitentsDetail.email}</p>
                                    <p><span className="icon icon-hospital"></span>{paitentsDetail.facilities[0].facility.name}</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-xs-7 no-padding">

                            <div className="admin-details-buttons pull-right">


                                {(roleID != 1 && roleID != 2) && <button className="add gray-button" onClick={this.answerdSurvey}  >Most Recent Survey</button>}
                                {roleID === 8 &&
                                    <button className="add gray-button" onClick={this.addOptionalQuestions} >Optional Question(s)</button>
                                }

                                {roleID === 1 || roleID === 2 &&
                                    <div>
                                        <button className="add gray-button" onClick={this.addOptionalQuestions} >Optional Question(s)</button>

                                        {(paitentsDetail.facilities[0].status === "APPROVE" || paitentsDetail.facilities[0].status === "DEACTIVATED") &&
                                            <button className="edit gray-button" onClick={this.deactivatePatient} data-isactive={paitentsDetail.facilities[0].status === "APPROVE" ? 0 : 1} data-uq={paitentsDetail.uniqueKey} data-fac_id={paitentsDetail.facilities[0].facility.id} data-patient_id={paitentsDetail.id} > {paitentsDetail.facilities[0].status === "APPROVE" ? "DEACTIVATE" : "ACTIVATE"}</button>}


                                        {paitentsDetail.facilities[0].status === "APPROVE" && <button className="change gray-button" onClick={this.resetPwdModal} >Reset Password</button>}
                                        {(paitentsDetail.facilities[0].status === "APPROVE" || paitentsDetail.facilities[0].status === "ACCEPTED" || paitentsDetail.facilities[0].status === "EXPIRED") && <button className="edit gray-button" onClick={this.editPatient} >Edit</button>}
                                    </div>
                                }
                            </div>




                        </div>
                        <div className="col-xs-7 col-md-7 col-lg-7 no-padding text-right survey-analasys">
                            <button className="edit gray-button" onClick={this.checkUserSummery}  >Survey Summary</button>

                        </div>

                    </div>
                    <div className="facility-details-values">
                        <ul>
                            <li>
                                <p>TOTAL SURVEYS</p>
                                <h5>{paitentInfo && paitentInfo.totalSurveys}</h5>

                                {/* uncomment the below code and remove the above 2 lines when moving to prod env */}
                                {/* <p>DAILY SURVEY COMPLETION</p>
                                <h5>{paitentInfo && paitentInfo.totalDailyResponded} / {paitentInfo && paitentInfo.totalDailySurveys} ({Math.round((paitentInfo.totalDailyResponded / paitentInfo.totalDailySurveys) * 100)}%) </h5> */}
                            </li>
                            <li>
                                <p>TOTAL RESPONDED</p>
                                <h5>{paitentInfo && paitentInfo.totalResponded} </h5>

                                {/* uncomment the below code and remove the above 2 lines when moving to prod env */}
                                {/* <p>WEEKLY SURVEY COMPLETION</p>
                                <h5>{paitentInfo && paitentInfo.totalWeeklyResponded} / {paitentInfo && paitentInfo.totalWeeklySurveys} ({Math.round((paitentInfo.totalWeeklyResponded / paitentInfo.totalWeeklySurveys) * 100)}%) </h5> */}
                            </li>
                            {paitentsDetail.facilities[0].status === "APPROVE" && <li className="trigger-time">
                                <p>DAILY SURVEY TIME</p>
                                <div className='w-survey'>
                                    <h5 onClick={this.toggleDailyTriggerTime} className={this.state.isDailySurveyEdit ? 't-disabled' : ''}>{this.state.currentDailyTriggerTime ? this.state.currentDailyTriggerTime : (dTT ? dTT : "Select")}</h5>
                                    <img src={require('./../../../images/edit-icon.png')} onClick={() => { this.setState({ isDailySurveyEdit: !this.state.isDailySurveyEdit }) }} />
                                </div>
                                <ul className={this.state.showDailyTriggerTime ? "dropdown-timetrigger show" : "dropdown-timetrigger"}>
                                    {
                                        hours.map(function (hour, key) {
                                            return <li key={key} data-uq={paitentsDetail.uniqueKey} data-patient_id={paitentsDetail.id} data-hour={hour.value} onClick={this_1.triggerDailyTimer} >{hour.title}</li>;
                                        })
                                    }
                                </ul>
                            </li>}

                            {paitentsDetail.facilities[0].status === "APPROVE" && <li className="trigger-time">
                                <p>WEEKLY SURVEY TIME</p>
                                <div className='w-survey'>
                                    <h5 onClick={this.toggleWeeklyTriggerTime} className={this.state.isWeeklySurveyTimeEdit ? 't-disabled' : ''}>{this.state.currentWeeklyTriggerTime ? this.state.currentWeeklyTriggerTime : (wTT ? wTT : "Select")}</h5>
                                    <img src={require('./../../../images/edit-icon.png')} onClick={() => { this.setState({ isWeeklySurveyTimeEdit: !this.state.isWeeklySurveyTimeEdit }) }} />

                                </div>
                                <ul className={this.state.showWeeklyTriggerTime ? "dropdown-timetrigger show" : "dropdown-timetrigger"}>
                                    {
                                        hours.map(function (hour, key) {
                                            return <li key={key} data-uq={paitentsDetail.uniqueKey} data-patient_id={paitentsDetail.id} data-hour={hour.value} onClick={this_1.triggerWeeklyTimer} >{hour.title}</li>;
                                        })
                                    }

                                </ul>
                            </li>}

                            {paitentsDetail.facilities[0].status === "APPROVE" && <li className="trigger-time">
                                <p>WEEKLY SURVEY DAY</p>
                                <div className='w-survey'>
                                    <h5 onClick={this.toggleWeeklyTriggerDay} className={this.state.isWeeklySurveyDayEdit ? 't-disabled' : ''}>{this.state.currentWeeklyTriggerDay ? this.state.currentWeeklyTriggerDay : (WSD ? WSD : 'Select')}</h5>
                                    <img src={require('./../../../images/edit-icon.png')} onClick={() => { this.setState({ isWeeklySurveyDayEdit: !this.state.isWeeklySurveyDayEdit }) }} />
                                </div>
                                <ul className={this.state.showWeeklyTriggerDay ? "dropdown-timetrigger show" : "dropdown-timetrigger"}>
                                    {
                                        weeklySurveyDays.map(function (week, key) {
                                            return <li key={key} data-uq={paitentsDetail.uniqueKey} data-patient_id={paitentsDetail.id} id={week.key} onClick={this_1.triggerWeeklyDay} >{week.name}</li>;
                                        })
                                    }

                                </ul>
                            </li>}

                            {/* {paitentsDetail.facilities[0].status === "APPROVE" && <li className="trigger-time">
                                <p>Report Period</p>
                                <div className='w-survey'>
                                    <h5 onClick={this.toggleReportPeriod} className={this.state.isReportPeriodEdit ? 't-disabled' : ''}>{this.state.currentReportedPeriod ? this.state.currentReportedPeriod : 'Select'}</h5>
                                    <img src={require('./../../../images/edit-icon.png')} onClick={() => { this.setState({ isReportPeriodEdit: !this.state.isReportPeriodEdit }) }} />
                                </div>
                                <ul className={this.state.showReportPeriod ? "dropdown-timetrigger show" : "dropdown-timetrigger"}>
                                    {
                                        reportPeriod.map(function (period, key) {
                                            return <li key={key} data-uq={paitentsDetail.uniqueKey} data-patient_id={paitentsDetail.id} id={period.key} onClick={this_1.triggerReportPeriod} >{period.name}</li>;
                                        })
                                    }

                                </ul>
                            </li>} */}

                        </ul>
                    </div>
                    <div className="white-box">


                        <Tabs onSelect={this.handleSelect} selectedIndex={this.state.selectedTab}>

                            <TabList className="nav nav-tabs">

                                <Tab className="button">SURVEY LIST</Tab>
                                <Tab className="button">RED FLAGS {paitentInfo && "(" + paitentInfo.redflagsCount + ")"}</Tab>

                            </TabList>


                            <TabPanel>
                                <table className="table p">
                                    {surveList && surveList.length &&
                                        <thead><tr><th>Survey Type</th><th>Date
                                            {/* <span onClick={this.toggleSort.bind(this)}>{ this.state.sortDirection === 'd'? ' D' : (this.state.sortDirection === 'a'? ' A': ' S' )}</span> */}
                                            <img onClick={this.toggleSort} alt={this.state.sortDirection === 'd' ? ' D' : (this.state.sortDirection === 'a' ? ' A' : ' S')} className='sorting_icons' src={this.state.sortDirection === 'd' ? require('./../../../images/descending.svg') : (this.state.sortDirection === 'a' ? require('./../../../images/ascending.svg') : require('./../../../images/swap.svg'))} />
                                        </th>
                                            <th>Therapist</th><th>Psychiatrist</th><th>Status</th><th></th></tr></thead>
                                    }
                                    <tbody>
                                        {surveList}
                                    </tbody>

                                </table>
                            </TabPanel>

                            <TabPanel>
                                <div className="head">Filters: </div>
                                <div className="filters">
                                    <div className="filtertype">
                                        <div>{'From Date: '}</div><DayPickerInput className="date" onDayChange={(selectedDay) => {
                                            this.setState({ selectedFromDate: selectedDay ? selectedDay._d : null }, () => {
                                                this.getRedFlags()
                                            })
                                        }} dayPickerProps={startDayPickerProps} placeholder="MM/DD/YYYY" />
                                    </div>
                                    <div className="filtertype">
                                        <div className="todate">{'To Date: '}</div> <DayPickerInput className="date" onDayChange={(selectedDay) => {

                                            this.setState({ selectedToDate: selectedDay ? selectedDay._d : null }, () => {
                                                this.getRedFlags()
                                            })
                                        }} dayPickerProps={endDayPickerProps} placeholder="MM/DD/YYYY" />
                                    </div>
                                    <div className="filtertype">
                                        <select className='s-dropdown'
                                            onChange={(e) => {
                                                this.setState({ selectedDescription: e.target.value }, () => {
                                                    this.getRedFlags()
                                                })
                                            }}>
                                            <option value={''} default="">Select Type/Description</option>
                                            {this.state.descriptionFilters.map((reason) =>
                                                <option key={reason} value={reason}>{reason}</option>
                                            )}
                                        </select>

                                    </div>
                                    <div className="filtertype">
                                        <select className='s-dropdown'
                                            onChange={(e) => {
                                                this.setState({ selectedStatus: e.target.value }, () => {
                                                    this.getRedFlags()
                                                })
                                            }}>
                                            <option value={''} default="">Select Status</option>
                                            {this.state.statusList.map((reason) =>
                                                <option key={reason.id} value={reason.id}>{reason.name}</option>
                                            )}
                                        </select>

                                    </div>
                                    {(this.generateRedFlagList()).list.length > 0 &&
                                        (this.state.selectedStatus === '1') && <div className="filtertype">
                                            <button onClick={() => { this.onResolveAll() }} className='btn reslove text-center'> Resolve All</button>
                                            <button onClick={() => { this.addNotesToAll() }} className='btn reslove text-center'> Add Notes </button>
                                        </div>}

                                </div>
                                <div>{this.state.filterError}</div>
                                <table className="table">
                                    {(this.generateRedFlagList()).list.length && <thead><tr><th>Date</th><th>Type/Description</th></tr></thead>}
                                    <tbody>
                                        {(this.generateRedFlagList()).list}
                                    </tbody>

                                </table>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>

                <div>  {this.state.modal_pwd ? <ModalDialogCommon message={this.state.modal_msg} action={this.closebox} /> : ""} </div>
                <div>  {this.state.isActivation ? <ModalDialogCommon message={this.state.modal_msg} cancel="true" action2={this.closebox} action={this.deactivatePatientYes} /> : ""}</div>
                <div>  {this.state.resetpwd ? <RestPwdDialog confirm={this.resetPassword} cancel={this.closebox} errorMessage={this.state.resetPasswordResponseError} removeErrorMessage={this.removeResetPasswordResponseError} /> : ''}  </div>
                {this.state.showFlagsModel && <Modal isOpen={this.state.showFlagsModel} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile OTP_content text-center">
                        <span className='resolve-history' onClick={() => { this.showResolvedHistoy(this.state.flagData.id) }}>History</span>
                        <p className='verify_text'>How was this red flag used as part of care?</p>
                        <div className="question-selection">
                            <select
                                onChange={(e) => {
                                    this.onChange('reason', e.target.value);
                                    this.setState({ errors: '', customReason: '' })
                                }}>
                                <option value={''} default="">Select Action Taken</option>
                                {this.state.responseReason.data && this.state.responseReason.data.map((response) =>
                                    <option key={response.id} value={response.id}>{response.reason}</option>
                                )}
                            </select>
                        </div>
                        {this.state.viewCustomREason &&
                            <div>
                                <textarea placeholder={'Enter reason here...'} className="textarea_style"
                                    maxLength={500} onChange={(e) => { this.setState({ customReason: e.target.value }) }} />
                                <span className="error">{this.state.errors}</span>
                            </div>}
                        <div>
                            <input type='button' value='SUBMIT' className={this.state.selectedResponse === '' ? 'button button-primary btn-submit btn-disabled' : 'button button-primary btn-submit gray-button'}
                                disabled={this.state.selectedResponse === '' ? true : false} ref='deleteBtn' onClick={this.updatePatientDetails} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.closePatientDetails} />
                        </div>
                    </div>
                </Modal>}

                {this.state.showResponseModel && <Modal isOpen={this.state.showResponseModel} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile OTP_content text-center">
                        {/* <p className='verify_text'>Reason Added</p> */}
                        <p className='verify_text'>Action Taken</p>
                        <span className='resolve-history' onClick={() => { this.showResolvedHistoy(this.state.flagData.id) }}>History</span>
                        <p>"{this.state.flagData.reason}"</p>
                        <div className="resolvedBy">
                            <span className="head">{'Resolved By: '}</span><span>{this.state.flagData.flagResolvedBy}</span>
                        </div>
                        <div className="resolvedBy">
                            <span className="head">{'Resolved On: '}</span><span>{this.state.flagData.flagResolvedDate ? this.formatDate(this.state.flagData.flagResolvedDate) : 'N/A'}</span>
                        </div>
                        <input type='button' value='OK' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.closeResponse} />
                    </div>
                </Modal>}
                {this.state.showLoader && <Loader />}
                {this.state.showLogs && <Modal isOpen={this.state.showLogs} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile OTP_content text-center log_popup">
                        <div className="close_div">
                            <span className="close_logs" notification-close onClick={() => { this.closeLogs() }}>X</span>
                        </div>
                        <p className='verify_text'>Notes</p>
                        {<div className="message_box">
                            {this.props.LogsList && this.state.selectedId !== 0 && this.props.LogsList.data.length > 0 && <div className="messages">
                                {this.props.LogsList.data.map(data => <div className="message_text">
                                    <div>{data.text}</div>
                                    <div className="notesDate">{(new Date(data.date)).toDateString()}</div>
                                </div>)}
                            </div>}
                            {this.props.LogsList && this.props.LogsList.data.length === 0 && <div>
                                No notes to display
                            </div>}
                            {<div className="input_box" >
                                {<input className="input_field" key={this.state.selectedId !== 0 ? this.props.LogsList.data.length : 0} type="text" id='logText' onChange={(e) => { this.setState({ logText: e.target.value }) }}></input>}
                                <button onClick={() => this.sendLog()} className="msg_btn" disabled={(this.state.logText === '' || this.state.logText.charAt(0) === ' ') ? true : false}>Send</button>
                            </div>}
                        </div>}
                    </div>
                </Modal>}
                {
                    this.state.showResolvedFlagsHistoryPopup && <div className='h-popup'>
                        <div className='h-list popup-content'>
                            <span className='h-close' onClick={() => { this.setState({ showResolvedFlagsHistoryPopup: false }) }}>x</span>
                            <p className='verify_text'>Action Taken</p>
                            <div className='h-scroll'>
                                {resolvedFlagsHistoryList && resolvedFlagsHistoryList.length > 0 && resolvedFlagsHistoryList.map((list, index) => {
                                    return (
                                        <div className='h-list-view' key={index}>
                                            <p>"{list.text}"</p>
                                            <div className="resolvedBy">
                                                <span className="head">{'Resolved By: '}</span><span>{list.user}</span>
                                            </div>
                                            <div className="resolvedBy">
                                                <span className="head">{'Resolved On: '}</span><span>{list.date}</span>
                                            </div>
                                        </div>
                                    )
                                })}
                                {resolvedFlagsHistoryList && resolvedFlagsHistoryList.length === 0 && <p className='text-center'>No History Available</p>}
                            </div>
                        </div>
                    </div>
                }
                {this.state.showLoader && <div className='loader-s'><div className="loader"></div></div>}
            </div>

        );
    }
});

let mapStateToProps = (state) => {
    return {
        PatientsDetails: state.Patients,
        UserDetails: state.User,
        Setting: state.Setting,
        FacilitiesDetails: state.Facilites,
        TimeStamp: state.Patients.TimeStamp,
        Reasons: state.Reasons.ReasonDetails,
        Updated: state.Reasons.ReasonPutResponse,
        LogsList: state.Reasons.LogsList,
        LogResponse: state.Reasons.LogResponse,
        HistoryResponse: state.Reasons.HistoryResponse
    };
};

let mapDispatchToProps = (dispatch) => ({
    PatientsActions: bindActionCreators(PatientsActions, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    ReasonActions: bindActionCreators(ReasonActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(PatientsDetails));


//  <div className="button pull-right all-days"> <button className="icon-box">ALL DAYS</button>  </div>



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/patients-details.js
 **/